import { render } from "./MainNavigationDrawer.vue?vue&type=template&id=3b61b025"
import script from "./MainNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./MainNavigationDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__